const slider = document.querySelector(".horizontal-scroll__container");
const sliderWrapper = document.querySelector(".horizontal-scroll__wrapper");
const mainMenu = document.querySelector("[data-main-header-menu-wrapper]");
const slides = document.querySelectorAll(".horizontal-scroll__item");
const overlays = document.querySelectorAll(".horizontal-scroll__overlay");
const raffleTitles = document.querySelectorAll("[data-raffle-title]");
const lookbookTitles = document.querySelectorAll("[data-lookbook-title]");
const scrollbar = document.querySelector(".horizontal-scroll__bar");
const hamburger = document.querySelector(".site-header__hamburger-button");
const hamburgerOverlay = document.querySelector(".hamburger-menu__overlay");
const body = document.body;
const sliderImages = Array.from(document.querySelectorAll('.horizontal-scroll__image'));

// Helper function used in other js files (i.e. theme-custom.js), so using 'function' so we can declare it multiple times with the same exact name
function getRandomSize(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}


let canScrollX = true;

// If 'no-scoll' added to body, disable horizontal scrolling as well
const bodyObserver = new MutationObserver(() => {
  canScrollX = !body.classList.contains('no-scroll');
});
bodyObserver.observe(body, {attributes: true, childList: false, subtree: false});

// block the window to avoid Y scroll and bounce
body.style.position = "fixed";

// detect mouse direction and add custom cursor
let direction = "";
let oldX = 0;

const changeCursor = e => {
  if (e.pageX < oldX) {
    slider.classList.remove("horizontal-scroll--scroll-left");
    slider.classList.add("horizontal-scroll--scroll-right");
  } else if (e.pageX > oldX) {
    slider.classList.add("horizontal-scroll--scroll-left");
    slider.classList.remove("horizontal-scroll--scroll-right");
  }

  oldX = e.pageX;
}

document.addEventListener("mousemove", changeCursor);

// enable normal scroll on main menu for smaller screens
mainMenu.addEventListener("mouseover", (e) => {
  body.classList.add("no-scroll");
});

mainMenu.addEventListener("mouseout", (e) => {
  body.classList.remove("no-scroll");
});

// custom scrollbar
window.addEventListener("wheel", (e) => {
  let position = 0;
  let step =
    (slider.scrollLeft / slider.scrollWidth) * (window.innerHeight + 15);

  position += step;

  scrollbar.style.top = `${position}px`;
});


// start wheel event for horizontal scroll
window.addEventListener(
  "wheel", e => 
  {
    // check if hamburger menu is open and in that case scroll normally
    if (canScrollX != false) {
      e.preventDefault();

      // move container horizontally
      e.deltaY > 0
        ? slider.scrollLeft += e.deltaY
        : slider.scrollLeft -= Math.abs(e.deltaY);
    }
    // hide menu on scroll
    slider.scrollLeft > 80
      ? mainMenu.classList.add("hidden")
      : mainMenu.classList.remove("hidden");
  },
  {
    capture: false,
    passive: false,
  }
);

// detect scroll on mobile swipe as there is no wheel event
document.addEventListener("touchmove", () => {
  // Hide main-header-menu if swiped by a certain amount
  slider.scrollLeft > 40 
    ? mainMenu.classList.add("hidden") 
    : mainMenu.classList.remove("hidden");
});

// show overlays only when swipe stops
const overlayTimeout = 200;

document.addEventListener("touchend", () => {
  showOverlaysOnTouchEnd();
});

document.addEventListener("touchmove", () => {
  hideOverlaysOnTouch();
});

document.addEventListener("touchstart", () => {
  hideOverlaysOnTouch();
});

const showOverlaysOnTouchEnd = () => {
  overlays.forEach((el) => {
    setTimeout(() => {
      el.style.opacity = 1;
    }, overlayTimeout);
  });

  raffleTitles.forEach((title) => {
    setTimeout(() => {
      const words = Array.from(title.children[0].children);
      words.forEach((child) => {
        showMobileTitle(child);
      });
    }, overlayTimeout);
  });

  lookbookTitles.forEach((title) => {
    setTimeout(() => {
      const words = Array.from(title.children[0].children);
      words.forEach((child) => {
        showMobileTitle(child);
      });
    }, overlayTimeout);
  });
}

const hideOverlaysOnTouch = () => {
  overlays.forEach((el) => {
    el.style.opacity = 0;
  });

  raffleTitles.forEach((title) => {
    setTimeout(() => {
      const words = Array.from(title.children[0].children);
      words.forEach((child) => {
        hideMobileTitle(child); 
      });
    }, overlayTimeout);
  });

  lookbookTitles.forEach((title) => {
    setTimeout(() => {
      const words = Array.from(title.children[0].children);
      words.forEach((child) => {
        hideMobileTitle(child); 
      });
    }, overlayTimeout);
  });
}

const showMobileTitle = element => {
  element.style.clipPath = "inset(0 0 0% 0)";
  element.style.webkitTransform = "translate3d(0, 0, 0)";
  element.style.MozTransform = "translate3d(0, 0, 0)";
  element.style.OTransform = "translate3d(0, 0, 0)";
  element.style.transform = "translate3d(0, 0, 0)";
}

const hideMobileTitle = element => {
  element.style.clipPath = "inset(0px 0px 80% 0px)";
  element.style.webkitTransform = "translateY(0, 75%, 0)";
  element.style.MozTransform = "translateY(0, 75%, 0)";
  element.style.OTransform = "translateY(0, 75%, 0)";
  element.style.transform = "translateY(0, 75%, 0)";
}

// detect image orientation for sizing
const imgLazy = document.querySelectorAll(".horizontal-scroll__item img");
const imgContainer = document.querySelectorAll(".horizontal-scroll__image");

imgLazy.forEach((image, i) => {
  const aspectRatio = image.dataset.aspectratio;
  const landscape =
    screen.width >= 1024
      ? `${getRandomSize(700, 800)}px`
      : `${getRandomSize(450, 500)}px`;
  const portrait =
    screen.width >= 1024
      ? `${getRandomSize(450, 650)}px`
      : `${getRandomSize(400, 450)}px`;
  const square =
    screen.width >= 1024
      ? `${getRandomSize(650, 750)}px`
      : `${getRandomSize(400, 450)}px`;

  imgContainer[i].style.width = 
    aspectRatio > 1 ? landscape
    : aspectRatio < 1 ? portrait
    : square;
});

// double check raffle expiration
const message = document.querySelectorAll("[data-message]");
const nodeListArray = Array.from(message);

if (nodeListArray.length > 0) {
  slides.forEach((slide, i) => {
    const deadline = slide.dataset.deadline;
    const today = new Date().getTime();
    const countdownInSeconds = (deadline - today) / 1000;

    if (countdownInSeconds <= 0) {
      message[i].innerHTML = "Raffle is closed";
      message[i].classList.add("horizontal-scroll__message--red");
    }
  });
}

// text animations
const generateSplitTitles = title => {
  const cleansedTitle = title.replace(/\\/g, "");
  const splitTitle = cleansedTitle.split(" ").map(
    (w, i) =>
      `<span class="text-transition" style="-webkit-transition-delay:${i / 45}s;
         -o-transition-delay:${i / 45}s;
            transition-delay:${i / 45}s">${w}</span>`
  );
  return `<span class="text-transition__container--mobile">${cleansedTitle}</span><div class="text-transition__container--desktop" style="font-weight: 900; text-transform: uppercase;">${splitTitle.join(" ")}</div>`;
}

raffleTitles && raffleTitles.forEach((title) => {
  title.innerHTML = generateSplitTitles(title.dataset.raffleTitle);
});

lookbookTitles && lookbookTitles.forEach((title) => {
  title.innerHTML = generateSplitTitles(title.dataset.lookbookTitle);
});